<template>
<div class="touch">
<span class="material-icons">touch_app</span> 
<span>{{ $t('preview.DragToScroll') }}</span>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

.touch{
align-items: center;
justify-content: center;
color: white;
font-family: "Montserrat", sans-serif;
font-optical-sizing: auto;
font-style: normal;
}

.material-icons{
font-size: 30px;
}

</style>